import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../../../../src/constants';

export default StyleSheet.create({
  topRow: {
    paddingBottom: 3,
  },
  bottomRow: {
    paddingTop: 3,
  },
  pdfLink: {
    paddingBottom: 10,
  },
  positive: {
    color: PALETTE.primaryPositive,
  },
  negative: {
    color: PALETTE.primaryNegative,
  },
  neutral: {
    color: PALETTE.primaryText,
  },
  numberTx: {
    marginRight: -20
  },
  activeItem: {
    color: PALETTE.secondaryActive
  },
});
